import axios from 'axios'

class PeerCoachingService {
  constructor() {
    this.baseUrl = '/api/v1/peercoaching/'
  }

  getReasonProviderType() {
    return axios.get(`${this.baseUrl}providertypereasons/`)
  }

  postStartChatDetails(patient) {
    return axios.post(`${this.baseUrl}sendmessagetoqueue/`, patient)
  }

  endSecureChat(data) {
    return axios.post(`${this.baseUrl}endchat/`, data)
  }
}

export const peerCoachingService = new PeerCoachingService()
